<template>
  <div class="preview_wrapper_row_wrapper">
    <div
      class="preview_wrapper_row"
      :style="`position: absolute;width: ${row.width}px;height: ${row.height}px;top: ${row.top}px`"
      v-for="(row, index) in rows"
      :key="index"
    >
      <div
        class="position_remind_text"
        v-show="index != 0"
        :style="`${
          acCardPanes === 1 ? 'padding-top: 21px;' : 'padding-top: 18px;'
        }`"
      >
        <span class="position_remind_value" v-show="index != 0">请在各题目的答题区域内作答，超出黑色矩形边框限定区域的答案无效</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    myStyle: {
      type: Object,
      default: () => {
        return {
          width: 0,
          height: 0,
        };
      },
    },
    acCardPanes: {
      type: Number,
      default: 1,
    },
    topicTotalNum: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    rows() {
      let rows = [];
      const num = Math.ceil(this.topicTotalNum / this.acCardPanes);
      let top = 0;
      for (let i = 0; i < num; i++) {
        top = i * this.myStyle.height;
        rows.push({
          width: this.myStyle.width,
          height: this.myStyle.height,
          left: 0,
          top: top,
        });
      }
      console.log("a大萨达萨达", rows);
      return rows;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.preview_wrapper_row_wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  .preview_wrapper_row {
    z-index: 9;
  }
  .position_remind_text {
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
}
</style>